import { Word } from "./types/dict"

export const typeClass: any = {
    "名詞": "noun",
    "接頭辞": "prefix",
    "接尾辞": "suffix",
    "代名詞": "pronoun",
    "及動詞": "affective-verb",
    "不及動詞": "inaffective-verb",
    "特殊動詞": "special-verb",
    "形容詞": "adjective",
    "副詞": "adverb",
    "助詞": "particle",
    "助数詞": "quantifier",
    "感動詞": "interjection",
    "接続詞": "conjunction",
    "数詞": "numeral",
    "情詞": "modal",
    "前置詞": "preposition",
    "成句": "idiom",
    "造語成分": "morpheme"
}

export function toPhunnum(num: string) {
    const PhunNum: any = {
        "0": "〇",
        "1": "〡",
        "2": "〢",
        "3": "〣",
        "4": "〤",
        "5": "〥",
        "6": "〦",
        "7": "〧",
        "8": "〨",
        "9": "〩",
        "a": "〹",
        "b": "〺",
        ".": "・",
    }

    return num.toString().split("").map(e => {
        return PhunNum[e]
    }).join("")
}

export const sendForm = async (data: { [key: string]: string }, url: string) => {
    try {
        const options = {
            method: 'POST',
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify(data),
        }

        const response = await fetch(url, options)
        const result = await response.json()

        if (result.status === "success") {
            return true
        } else {
            console.error("GAS Error:", result.message);
            return false
        }
    } catch (e) {
        return false
    }
}

export async function FetchDictData(url: string) {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            throw new Error("データの取得に失敗しました");
        }

        const data = await res.json();
        return data
    } catch (error) {
        console.error(error);
        throw error
    }
};

const isIncludes = (data: any[], entry: string, filter: string, rule: string) => {
    return data.some((m: any) => {
        return m.explanation.some((e: any) => {
            return searchWithRule(e[entry], filter, rule)
        })
    })
}

export function clipDict(dict: Word[], filter: string = "", type: string = "word", rule: string = "part", sort: string = "weqo") {
    let filtedWords = dict.filter((w: any) => {
        switch (type) {
            case "all":
                const searchBool = [
                    isIncludes(w.mean, "translate", filter, rule),
                    isIncludes(w.mean, "meaning", filter, rule),
                    isIncludes(w.append, "translate", filter, rule),
                    searchWithRule(w.pron, filter, rule),
                    searchWithRule(w.word, filter, rule),
                ]
                return searchBool.some(b => b)
            case "mean":
                return isIncludes(w.mean, "translate", filter, rule) || isIncludes(w.mean, "hidden", filter, rule) //隠れ語義も検索
            case "pron":
                return searchWithRule(w.pron, filter, rule) || searchWithRule(w.latinPron, filter, rule)
            case "word":
            case "id":
                return searchWithRule(String(w[type]), filter, rule) //mean以外の時はこっち
            default:
                return false //許可されていないキーは阻止
        }
    })

    const sorted = sortWithRule(filtedWords, sort)

    return sorted
}

export function clipForPage(dict: Word[], page: number, words: number) {
    return (
        dict.filter((a, idx) => {
            return Math.floor(idx / words) == page
        })
    )
}

const sortWithRule: (dict: Word[], sort: string) => Word[] = (dict: Word[], sort: string) => {
    switch (sort) {
        case "uni":
            return dict.sort((a, b) => {
                if (a.word > b.word){
                    return 1;
                } else if (a.word < b.word) {
                    return -1;
                } else {
                    return 0;
                }
            })
        case "weqo":
            return dict.sort((a, b) => {
                return a.sortKey - b.sortKey
            })
        case "id":
            return dict.sort((a, b) => {
                return a.id - b.id
            })
        case "random":
            for (let i = dict.length - 1; i > 0; i--) {
                const rand = Math.floor(Math.random() * (i + 1));
                [dict[i], dict[rand]] = [dict[rand], dict[i]]
            }
            return dict
        default:
            return dict
    }
}

function searchWithRule(word: string, filter: string, rule: string){
    if (!word) { //undefined等を弾く
        return false
    }

    switch(rule){
        case "part":
            return word.includes(filter)
        case "start":
            return word.startsWith(filter)
        case "end":
            return word.endsWith(filter)
        case "perfect":
            return word == filter
        case "regular":
            try {
                const reg = new RegExp(filter)
                return reg.test(word)
            } catch (e) {
                return false
            }
        default:
            return false
    }
}

export function getTotalPages(dict: any[], words: number) {
    return Math.ceil(dict.length / words)
}

export const sentenceToPron = (words: {text: string; pron?: string;}[], dict: Word[]) => {
    const marks: {[key: string]: string} = {
        "。": ".",
        "、": ",",
        "「": "“",
        "」": "”",
        "！": "!",
        "？": "?",
        "〈": "‹",
        "〉": "›",
        "（": "(",
        "）": ")",
        "―": "—",
        " ": "　",
    }

    const startMarks: {[key: string]: string} = {
        "「": "“",
        "〈": "‹",
        "（": "(",
    }

    const processed = words.map((w, idx) => {
        const displayText = w.text
        const isMark = Object.hasOwn(marks, displayText)
        const isStartMark = Object.hasOwn(startMarks, displayText)
        const wordEntry = dict.find(entry => entry.word == displayText)
        const wordPron = w.pron
            ? numberPronToLatin(w.pron) //発音指定のある文字はそれを雰拼に変換して表示
            : wordEntry
                ? wordEntry.latinPron
                : displayText //辞書にない単語ならそのまま表示
            
        const pron = isMark
            ? marks[displayText]
            : wordPron
        return ((isMark && !isStartMark) || Object.hasOwn(startMarks, words[idx - 1]?.text) || idx == 0) //自分が通常の符号か、自分の前が開始符号か、先頭の文字ならスペースを入れない
            ? pron 
            : " " + pron
    })

    return processed
}

function numberPronToLatin(prons: string) {
    const marks: {[key: string]: string[]} = {
        a: ["á", "à", "â"],
        i: ["í", "ì", "î"],
        u: ["ú", "ù", "û"],
        e: ["é", "è", "ê"],
        o: ["ó", "ò", "ô"]
    }

    const words = prons.split(" ")
    return words.map((p, idx) => {
        const splittedPron = p.match(/^(.*?)([aiueo]+)(.*)([123])$/)
        if (!splittedPron) { return "" }
        const [_, hC, V, coda, tone] = splittedPron

        const firstV = V[0] //母音字の一文字目
        const markedFirstV = marks[firstV][Number(tone) - 1] //母音字の一文字目をアクセント付きのものに変換

        const markedV = markedFirstV + V.slice(1) //母音全体を結合
        const latinPron = hC + markedV + coda //ラテン文字表記の全体

        if (!words[idx + 1]) { //語の末尾の文字であるとき
            return latinPron
        }

        const dictPron = p
        const nextPron = prons[idx + 1]

        const splitFlag =
            ( dictPron.match(/[slmn]\d$/g) && nextPron.match(/^[aiueo]/g) ) || //末子音と母音の曖昧さ回避
            ( dictPron.match(/[aiueo]\d$/g) && nextPron.match(/^[slmn]/g) ) ||
            ( dictPron.match(/ng\d$/g) && nextPron.match(/^[aiueo]/g) ) || //ngとg始まりの語の曖昧さ回避
            ( dictPron.match(/n\d$/g) && nextPron.match(/^g/g) )

        return splitFlag ? latinPron + "'" : latinPron //区切りが必要なときはアポストロフィーを挿入
    }).join("")
}